module.exports = __webpack_public_path__ + "static/media/pic_patient_overview@2x.d4f29cba.png";